import { useContext, createContext } from 'react';

/**
 * 네비게이션 컨텍스트 - useVirtualNavigation의 navigateToMode를 하위 컴포넌트에서 사용
 */
interface NavigationContextType {
  navigateToMode: (newMode: "call" | "text" | null) => void;
}

export const NavigationContext = createContext<NavigationContextType | null>(null);

/**
 * 채팅 모드 네비게이션 훅 - 컨텍스트를 통해 navigateToMode 함수 제공
 */
export const useNavigateChatMode = () => {
  const context = useContext(NavigationContext);

  if (!context) {
    throw new Error('useNavigateChatMode must be used within NavigationContext.Provider');
  }

  return context;
};
